import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import UserService from '../../services/UserService';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import tableRequest from '../../models/tableRequest.js';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { ConfirmationModal } from '../../template/ConfirmationModal';
import MessageComponent from '../../template/Message';
import $ from 'jquery';
export default class ListMaster extends Component {
    constructor(props) {
        super(props);
        this.UserService = new UserService();
        this.tblResponse = new tableRequest();
        this.state = {
            visible: false,
            ReferenceID: '',
            sortIcon:false,
            UserName: '',
            FirstName: '',
            LastName: '',
            Email: '',
            MobileNo: '',
            Password: '',
            ConfirmPassword: '',
            IsActive: null,
            sortOrder: '1',
            formError: {
                UserName: '',
                FirstName: '',
                LastName: '',
                Password: '',
                Email: '',
                ConfirmPassword: '',
                MobileNo: ''
            },

            formHeading: 'Add User',
            buttonLabel: 'Submit',
            sales: [],
            loading: true,
            first: 0,
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: 'No Data found'
        }

        this.actionTemplate = this.actionTemplate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.hideFunc = this.hideFunc.bind(this);
        this.onPage = this.onPage.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.onSort = this.onSort.bind(this);
    }

//to trigger api function on page call
    componentDidMount() {
        setTimeout(() => {
            this.GetUsers();
        }, 1000);

        $('.p-column-title').on('click', function(){
            $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
        });
    }
//loading page
    onPage(event) {
        this.setState({
            loading: true
        });

        //imitate delay of a backend call
        setTimeout(() => {
            this.getLazyLoadingValues(event);
            this.GetUsers();
        }, 250);
    }

    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = true;
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        //this.tblResponse.SortColumn = event.sortField;
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    }

    // get users data list from api
    GetUsers() {
        this.UserService.GetUsers(this.tblResponse).then(data => {
            const resdata = data.data;
            //response data not null
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.datasource = resdata.ResponseData;
                this.setState({
                    totalRecords: resdata.ResponseData[0].TotalRows,
                    first: (this.tblResponse.First - 1),
                    sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
                    loading: false
                });

            } 
            //response data is null
            else {
                this.datasource = null;
                this.setState({
                    totalRecords: 0,
                    first: 1,
                    sales: null,
                    loading: false,
                    updateLoader:true

                });
            }
        });
    }

    // call every change of form and validation part also
    handleChange(event) {

        const { name, value } = event.target;
        let errors = this.state.formError;

        const isValid = this.validateForm(value, name);
        this.setState({ errors, [name]: value });
    }

   //to validate form
    validateForm(value, name) {
        let errors = this.state.formError;
        let IsValid = true;

   //to validate each form field
        switch (name) {
            case 'UserName':
                if (value.length < 1) {
                    IsValid = false;
                    errors.UserName = "Please enter your username.";
                } else errors.UserName = ''
                break;
            case 'FirstName':
                if (value.length < 1) {
                    IsValid = false;
                    errors.FirstName = "Please enter your first name.";
                }
                else if (value.length >= 1) {
                
                    if (!value.match(/^[A-Za-z]+$/)) {
                        IsValid = false;
                        errors.FirstName = "FirstName should be alpha only."
                    } else errors.FirstName = ''
                }
                else errors.FirstName = ''
                break;
            case 'LastName':
                if (value.length < 1) {
                    IsValid = false;
                    errors.LastName = "Please enter your last name.";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^[A-Za-z]+$/)) {
                        IsValid = false;
                        errors.LastName = "LastName should be alpha only."
                    } else errors.LastName = ''
                }
                else errors.LastName = ''
                break;
            case 'Email':
                if (value.length < 1) {
                    IsValid = false;
                    errors.Email = "Please enter your email-id.";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
                        IsValid = false;
                        errors.Email = "Please enter valid email-id.";
                    } else errors.Email = ''
                } else errors.Email = ''
                break;
            case 'MobileNo':
                if (value.length < 1) {
                    IsValid = false;
                    errors.MobileNo = "Please enter your mobile no.";
                }
                else if (value.length >= 1) {
                    if (!value.match(/^[6-9]\d{9}$/)) {
                        IsValid = false;
                        errors.MobileNo = "Please enter valid mobile no.";
                    } else errors.MobileNo = ''
                } else errors.MobileNo = ''
                break;
            case 'Password':
                if (value.length < 1) {
                    IsValid = false;
                    errors.Password = "Please enter password.";
                }
                else if (value.length >= 1 && this.state.ConfirmPassword.length >= 1) {
                    errors.Password = '';
                    errors.ConfirmPassword = '';
                    if (!(value === this.state.ConfirmPassword)) {
                        IsValid = false;
                        errors.Password = "password does not match";
                    } else errors.Password = ''
                } else errors.Password = ''
                break;

            case 'ConfirmPassword':
                if (value.length < 1) {
                    IsValid = false;
                    errors.ConfirmPassword = "Please enter confirm password.";
                }
                else if (value.length >= 1 && this.state.Password.length >= 1) {
                    errors.Password = '';
                    errors.ConfirmPassword = '';
                    if (!(value === this.state.Password)) {
                        IsValid = false;
                        errors.ConfirmPassword = "Confirm password does not match";
                    } else errors.ConfirmPassword = ''
                } else errors.ConfirmPassword = ''
                break;

            case 'IsActive':
                this.setState({
                    IsActive: value
                });
                break;

            default:
                break;
        }

        return IsValid;
    }

    // reset form text value
    formReset() {
        this.setState({
            ReferenceID: '',
            UserName: '',
            FirstName: '',
            LastName: '',
            Email: '',
            MobileNo: '',
            Password: '',
            ConfirmPassword: '',
            IsActive: true

        });
        let errors = this.state.formError;
        Object.entries(errors).map(([key, value]) => {
            errors[key] = '';
        });
    }

    hideFunc() {
        this.setState({
            visible: false, buttonLabel: 'Submit',
            formHeading: 'Add User'
        })
        this.formReset();
    }
    openDialog() {
        this.setState({ visible: true });
        this.formReset();
    }
    // submit form and create or update user
    submitForm(event) {
        event.preventDefault();

        let isfrmvalid = true;
        let checkerror = this.state.formError;

        Object.entries(checkerror).map(([key, value]) => {
            const val = this.state[key]
            let valid = this.validateForm(val, key);
            //to form is valid or not
            if (!valid) {
                this.setState({ checkerror: isfrmvalid });
                isfrmvalid = false;
            }
        });

      // when form is valid
        if (isfrmvalid) {
            const formData = {
                UserName: this.state.UserName,
                FirstName: this.state.FirstName,
                LastName: this.state.LastName,
                Email: this.state.Email,
                MobileNo: this.state.MobileNo,
                Password: this.state.Password,
                ReferenceID: this.state.ReferenceID,
                IsActive: true

            }

            setTimeout(() => {
                this.UserService.CreateUpdateUser(formData).then(data => {
                    const resdata = data.data;
            //when data is not null it will give success message else will move to 'else statement'
                    if (resdata !== null && resdata.ResponseCode === '200') {
                        this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                        this.setState({
                            loading: true,
                            visible: false
                        });
                        this.formReset();
                        this.GetUsers();
                    } else if (resdata.ResponseCode === '400') {
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                    } else {
                        this.refs.Messchild.showError(resdata.ResponseMessage);
                    }
                });
            }, 1000);
        }
    }

    // delete user data
    deleteUser(referenceID) {
        this.UserService.DeleteUser(referenceID).then(data => {
            const resdata = data.data;
        //when data is not null it will give success message else will move to 'else statement'
            if (resdata !== null && resdata.ResponseCode === '200') {
                this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                const totlrecord = this.state.totalRecords - 1;
                const row = this.state.rows;

                if (this.tblResponse.First >= totlrecord) {
                    const _curntCursor = Math.round(totlrecord / row);
                    this.tblResponse.First = _curntCursor + 1;
                }
                this.GetUsers();
            } else if (resdata.ResponseCode === '400') {
                this.refs.Messchild.showWarn(resdata.ResponseMessage);
            } else {
                this.refs.Messchild.showError(resdata.ResponseMessage);
            }
        });
    }

    searchFilter(e) {
        this.setState({
            loading: true
        });
        this.tblResponse.SearchValue = e.target.value;
        this.GetUsers();
    }

    callbackFunction = (childData) => {
        this.setState({ message: childData })
    }

    activeTemplate(rowData, column) {
        return (
            <input type="checkbox" disabled checked={rowData.IsActive} />
        )
    }

    onSort(event) {        
        this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1, sortIcon: !this.state.sortIcon });
        const sortField = event.sortField == "CreatedDate" ? "CreatedDt" : event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.GetUsers();
        const clickData = document.getElementsByClassName("p-sortable-column-icon pi pi-fw pi-sort");        
        console.log(event);
    }

    // edit form 
    actionTemplate(rowData, column) {
        const editMode = (e) => {
            this.setState({
                buttonLabel: 'Update',
                formHeading: 'Update User',
                visible: true, ReferenceID: rowData.ReferenceID,
                UserName: rowData.Username,
                FirstName: rowData.FirstName,
                LastName: rowData.LastName,
                Email: rowData.Email,
                MobileNo: rowData.MobileNo,
                Password: rowData.Password,
                ConfirmPassword: rowData.Password,
                IsActive: rowData.IsActive

            });
        }

        const deleteFunc = () => {

            confirmAlert({
                title: 'Confirm to delete',
                message: 'Are you sure to do this.',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => this.deleteUser(rowData.ReferenceID)

                    },
                    {
                        label: 'No',
                        onClick: () => null
                    }
                ]
            });
        }

        return <span>
            <Button type="button" icon="pi pi-pencil" onClick={editMode} className="p-button-warning" style={{ marginRight: '3px' }}></Button>
            <Button type="button" icon="pi pi-trash" onClick={deleteFunc} className="p-button-danger"></Button>
        </span>;
    }

    // create html part
    render() {
        let header = (
            <div style={{ 'textAlign': 'right' }}>
                <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                <InputText type="search" onInput={this.searchFilter} placeholder="Global Search" size="30" />
            </div>
        );
        
        return (
            <>
                <MessageComponent ref="Messchild" />
                <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />
                <div className="heading">
                    <h1>List Master</h1>
                    <Button label="Add List" icon="pi pi-plus-circle" onClick={this.openDialog} />
                </div>

                <DataTable responsive={true} header={header} globalFilter={this.state.globalFilter}
                    emptyMessage={this.state.emptyMessage} value={this.state.sales} sortMode="multiple" paginator={true}
                    rows={this.state.rows} rowsPerPageOptions={[5, 10, 20]}
                    totalRecords={this.state.totalRecords} lazy={true} first={this.state.first}
                    onPage={this.onPage} onSort={this.onSort} loading={this.state.loading} className="tblAuto">

                    <Column field="Username" header="List Type" sortable={true} />
                    <Column field="FirstName" header="List Id" sortable="custom" />
                  
                    <Column field="CreatedDate" header="Created Date" sortable={true} />
                    <Column body={this.activeTemplate} header="Status" />
                    <Column body={this.actionTemplate} header="Action" />
                </DataTable>

                <Dialog className="popup-modal" header={this.state.formHeading} visible={this.state.visible} modal={true} onHide={this.hideFunc}>
                    <form onSubmit={this.submitForm}>
                        <div className="row">
                            <div className="col-md-4 text-right">
                                <label>User Name<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="text" value={this.state.UserName} onChange={this.handleChange} className="form-control" name="UserName" noValidate />
                                {this.state.formError.UserName !== '' ?
                                    <div className='error'>{this.state.formError.UserName}</div> : ''}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>First Name<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="text" value={this.state.FirstName} onChange={this.handleChange} className="form-control" name="FirstName" />
                                {this.state.formError.FirstName !== '' ?
                                    <div className='error'>{this.state.formError.FirstName}</div> : ''}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>Last Name<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="text" value={this.state.LastName} onChange={this.handleChange} className="form-control" name="LastName" />
                                {this.state.formError.LastName !== '' ?
                                    <div className='error'>{this.state.formError.LastName}</div> : ''}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>Email<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="text" value={this.state.Email} onChange={this.handleChange} className="form-control" name="Email" />
                                {this.state.formError.Email !== null ?
                                    <div className='error'>{this.state.formError.Email}</div> : null}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>Mobile Number<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="text" maxLength={10} value={this.state.MobileNo} onChange={this.handleChange} className="form-control" name="MobileNo" />
                                {this.state.formError.MobileNo !== null ?
                                    <div className='error'>{this.state.formError.MobileNo}</div> : null}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>Password<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="password" autoComplete="off" value={this.state.Password} onChange={this.handleChange} className="form-control" name="Password" noValidate />
                                {this.state.formError.Password !== null ?
                                    <div className='error'>{this.state.formError.Password}</div> : null}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>Confirm Password<span>*</span>:</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="password" autoComplete="off" value={this.state.ConfirmPassword} onChange={this.handleChange} className="form-control" name="ConfirmPassword" />
                                {this.state.formError.ConfirmPassword !== null ?
                                    <div className='error'>{this.state.formError.ConfirmPassword}</div> : null}
                            </div>
                            <div className="col-md-4 text-right">
                                <label>IsActive :</label>
                            </div>
                            <div className="col-md-8 mb-2">
                                <input type="checkbox" spellCheck={this.state.IsActive} className="ml-2" name="IsActive" onChange={this.handleChange} />
                            </div>
                            <div className="col-md-12 text-center">
                                <button type="submit" className="btn btn-primary">{this.state.buttonLabel}</button>
                            </div>
                            <div className="col-md-4 text-right">
                                <label>Note: Fields marked as (<span style={{ color: 'red' }}>*</span>) are required</label>
                            </div>
                        </div>
                    </form>
                </Dialog>
            </>
        )
    }
}